import React from "react"
import {MainCP} from "../../Components/percepcion-abuso/MainCP"

const ViewPercepcionAbuso: React.FC = () => <MainCP/>

export default ViewPercepcionAbuso;